import { Box, Paper, Stack, Typography } from "@mui/material";

const DashboardSummary = ({ category }) => {
  const maximum = Math.max(
    ...category.summary.map((status) => status.count),
    1
  );

  return (
    <Paper
      component="section"
      aria-labelledby="dashboard-summary-title"
      variant="outlined"
      sx={{ overflow: "hidden", borderRadius: 2 }}
    >
      <Box
        sx={{
          px: 2,
          py: 1.5,
          borderBottom: 1,
          borderColor: "divider",
          backgroundColor: "#dff2ff",
        }}
      >
        <Typography id="dashboard-summary-title" component="h2" variant="h4">
          Σύνοψη καταστάσεων
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Συγκεντρωτικά στοιχεία κατηγορίας
        </Typography>
      </Box>

      {category.summary.length === 0 ? (
        <Typography color="text.secondary" sx={{ p: 3, textAlign: "center" }}>
          Δεν υπάρχουν διαθέσιμα στοιχεία καταστάσεων.
        </Typography>
      ) : (
        <Box
          sx={{
            p: 2,
            display: "grid",
            gridTemplateColumns: {
              xs: "minmax(0, 1fr)",
              sm: "repeat(2, minmax(0, 1fr))",
            },
            columnGap: 2,
            rowGap: 1.75,
          }}
        >
          {category.summary.map((status) => {
            const width =
              status.count === 0
                ? 0
                : Math.max((status.count / maximum) * 100, 3);

            return (
              <Box
                key={status.statusId}
                sx={{
                  minWidth: 0,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="baseline"
                  spacing={1}
                  sx={{ mb: 0.5 }}
                >
                  <Typography
                    variant="body2"
                    sx={{ minWidth: 0, overflowWrap: "anywhere" }}
                  >
                    {status.statusName}
                  </Typography>
                  <Typography
                    variant="body2"
                    fontWeight={700}
                    sx={{ flexShrink: 0 }}
                  >
                    {status.count.toLocaleString("el-GR")}
                  </Typography>
                </Stack>
                <Box
                  aria-hidden="true"
                  sx={{
                    height: 10,
                    overflow: "hidden",
                    borderRadius: 10,
                    bgcolor: "grey.200",
                    mt: "auto",
                  }}
                >
                  <Box
                    className={status.statusCssClass}
                    sx={{ width: `${width}%`, height: "100%", borderRadius: 10 }}
                  />
                </Box>
              </Box>
            );
          })}
        </Box>
      )}
    </Paper>
  );
};

export default DashboardSummary;
